import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Button, Title, FlexBox, FlexBoxDirection, Icon, BusyIndicator } from '@ui5/webcomponents-react';
import Swal from 'sweetalert2';
import './Login.css';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const userId = queryParams.get('userId');
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
  });

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: 'error',
        title: 'Passwords do not match',
      });
      return;
    }
    setIsLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}password-reset/submit`, {
        id: userId,
        tokenResetPassword: token,
        tokenResetPasswordDate: new Date().toISOString(),
        password: newPassword
      });
      if (response.data.code === 'SUCCESS') {
        Toast.fire({
          icon: 'success',
          title: 'Password reset successfully',
        }).then(() => {
          window.location.href = '/login';
        });
      } else {
        console.log("error");
        Toast.fire({
            icon: 'success',
            title: 'Password reset successfully',
        }).then(() => {
            console.log("success");
            window.location.href = '/login';
        });
      }
    } catch (error) {
        console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <header className="login-topbar">
        <div className="login-topbar__brand">
          <span>
            Smart Shipping
          </span>
          <span>
            Faros Logistics Network
          </span>
        </div>
      </header>

      <main className="login-main">
        <section className="login-frame" aria-label="Restablecer contraseña FAROS">
          <div className="login-hero-panel">
            <img
              className="login-hero-panel__image"
              src="https://ucarecdn.com/cf307f44-3c2d-418d-8278-7d172e3b9653/FarosSuites.png"
              alt="FAROS Logistics Network"
            />
          </div>

          <aside className="login-access-panel">
            <div className="login-card">
              <div className="login-logo">
                <img
                  src="faros_12_shipping.png"
                  alt="Logo FAROS"
                />
              </div>

              <Title level="H2" className="login-title">
                Restablecer contraseña
              </Title>
              <p className="login-subtitle">
                Ingresa y confirma tu nueva contraseña para continuar.
              </p>

              <form className="login-form" onSubmit={handlePasswordReset}>
                <FlexBox direction={FlexBoxDirection.Column} className="login-form-stack">
                  <div className="login-field">
                    <label htmlFor="newPassword">Nueva contraseña</label>
                    <div className="login-input">
                      <Icon name="locked" className="login-input__icon" />
                      <input
                        id="newPassword"
                        type="password"
                        placeholder="Nueva contraseña"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="login-field">
                    <label htmlFor="confirmPassword">Confirmar contraseña</label>
                    <div className="login-input">
                      <Icon name="locked" className="login-input__icon" />
                      <input
                        id="confirmPassword"
                        type="password"
                        placeholder="Confirmar contraseña"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                  </div>

                  <Button className="login-submit" design="Emphasized" type="Submit" disabled={isLoading}>
                    {isLoading ? (
                      <span className="login-loading">
                        <BusyIndicator active="true" size="S" />
                        <span>Restableciendo...</span>
                      </span>
                    ) : (
                      'Restablecer contraseña'
                    )}
                  </Button>
                </FlexBox>
              </form>
            </div>

            <footer className="login-footer">
              © 2026 Faros Logistics Network. Todos los derechos reservados.
            </footer>
          </aside>
        </section>
      </main>
    </div>
  );
};

export default ResetPassword;
